<header class="page-header" *ngIf="showPageHeader$ | async">
	<stages-process-version
		*ngIf="showProcessVersionSwitch$ | async as showProcessVersionSwitch"
		[suppressTypeCheck]="disableTypeCheckForPVSwitch"
		[disableSwitch]="disablePVSwitch"
	></stages-process-version>

	<div class="breadcrumb-line">
		<stages-breadcrumb
			*ngIf="showBreadCrumb$ | async"
			[links]="(breadCrumbTemplate$ | async)!.links"
			[path]="(breadCrumbTemplate$ | async)!.path"
		></stages-breadcrumb>

		<ng-container *ngIf="showBackButton$ | async as showBackButtonTemp">
			<ng-container *ngIf="backButtonWithRouterLink$ | async as backButtonWithRouterLinkTemplate">
				<stages-backbutton
					*ngIf="showBackButtonTemp && (backButtonWithRouterLink$ | async) !== undefined"
					[backButton]="backButtonWithRouterLinkTemplate"
				></stages-backbutton>
			</ng-container>
			<stages-backbutton
				*ngIf="showBackButtonTemp && (backButtonWithRouterLink$ | async) === undefined"
				[isEmbeddedInCard]="isEmbeddedInCard"
				(backButtonClicked)="backButtonClicked.emit(true)"
			></stages-backbutton>
		</ng-container>
	</div>
	<ng-container *ngIf="headline$ | async as headlineTemp">
		<h1
			class="shorten"
			*ngIf="headlineTemp!.params !== undefined"
			[translate]="headlineTemp!.translate!"
			[translateParams]="headlineTemp!.params!"
		></h1>
		<ng-container *ngIf="!headlineTemp!.params">
			<h1 class="shorten" *ngIf="headlineTemp!.translate" [translate]="headlineTemp!.translate!"></h1>
			<h1 class="shorten" *ngIf="headlineTemp!.plainText">{{ headlineTemp!.plainText! }}</h1>
		</ng-container>
	</ng-container>
</header>
